export interface SetWidgetIdAction {
  type: "SET_WIDGET_ID";
  data: string;
}

export function setWidgetId(widgetId: string): SetWidgetIdAction {
  return {
    type: "SET_WIDGET_ID",
    data: widgetId,
  };
}
